import React from 'react';
import SproutsLoader from 'src/components/SproutsLoader';
import './AppSkeleton.scss';

const AppSkeleton: React.FC = () => (
  <div className="app-sk">
    <SproutsLoader />
  </div>
);

export default AppSkeleton;
